// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-logo {
  text-align: left;
  font-size: 20px;
  color: #fff;
  margin-left: 28px;
}

.fs20 {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;AACJ;;AACA;EACI,eAAA;AAEJ","sourcesContent":[".custom-logo{\r\n    text-align: left;\r\n    font-size: 20px;\r\n    color: #fff;\r\n    margin-left: 28px;\r\n}\r\n.fs20{\r\n    font-size: 20px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
